export default __webpack_public_path__ + "static/media/linode.1740d8a2.svg";